"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArticlesSlide = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _Article = require("./components/Article");
var _Slide = require("../Slide");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ArticlesSlide = props => {
  const {
    list
  } = props;
  return /*#__PURE__*/React.createElement(_Slide.Slide, {
    testId: "articleSlide"
  }, /*#__PURE__*/React.createElement(_uiKit.PromoModalBody, null, /*#__PURE__*/React.createElement(_uiKit.PromoModalTitle, null, "\u0427\u0438\u0442\u0430\u0442\u044C \u0432 \u0416\u0443\u0440\u043D\u0430\u043B\u0435"), list.map(article => /*#__PURE__*/React.createElement(_Article.Article, (0, _extends2.default)({
    key: article.id
  }, article)))));
};
exports.ArticlesSlide = ArticlesSlide;